/**
 * Ingredients hook
 * Thin wrapper around data layer using React Query
 */

import { useQuery } from "@tanstack/react-query";
import { ingredientKeys, queryOptions } from "@/data/query-keys";
import { getIngredients } from "@/data/supabase/menu";
import { getCurrentUserCompanyId } from "@/lib/userUtils";

// Re-export type for backward compatibility
export type { Ingredient } from "@/data/supabase/menu";

export const useIngredients = () => {
  return useQuery({
    queryKey: ingredientKeys.list(),
    queryFn: async () => {
      const companyId = await getCurrentUserCompanyId();
      if (!companyId) return [];
      return getIngredients(companyId);
    },
    staleTime: queryOptions.ingredients.staleTime,
    gcTime: queryOptions.ingredients.gcTime,
    refetchOnMount: true,
  });
};
